
















































































import Vue from "vue";
import Scroll from "@/utilities/Scroll";

export default Vue.extend({
  data: () => ({}),
  methods: {
    scrollAction: (param: any) => {
      let delayInMilliseconds = 2000;
      let scroll = new Scroll(param);
      let element: any = scroll.scroll();

      element.parentNode.style.backgroundColor = "rgba(224, 224, 224, 0.42)";
      element.parentNode.style.borderRadius = "10px";
      element.parentNode.style.boxShadow =
        "0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12)";

      setTimeout(function() {
        element.parentNode.style.backgroundColor = "rgba(224, 224, 224, 0.0)";
        element.parentNode.style.borderRadius = "";
        element.parentNode.style.boxShadow = "";
      }, delayInMilliseconds * 2);
    }
  }
});
